<template>
  <player v-if="isReady && !isEditor" id="#app" :class="site == '' ? 'wave-layout' : ''" :dirs='dirList'></player>
  <editor v-else-if="isReady" id="#app" :dirs='dirList' :stateid="stateid"></editor>
  <div v-else>
    
    <div class="loading-bar">
      <!-- <span>Loading</span><div :style="'width:'+((current/total)*100).toString()+'%;height:100%;'"></div> -->
    </div>
    <button id="app_load_check_button" v-on:click="updateLoad" style="display:none;"></button>
  </div>
</template>

<script>
import {EventBus} from './components/utils/EventBus.js'
import PlayerView from './components/PlayerView.vue'
import EditorView from './components/EditorView.vue'
import Sections from './components/utils/Sections.js'
export default {
  components: {
    player: PlayerView,
    editor: EditorView
  },
  data () {
    return {
      total: -1,
      current: 0,
      dirList: null,
      isReady: false,
      site: Sections.getSite()
    }
  },
  computed: {
    isEditor: function () {
      return document.getElementById('editormodeindicator').innerHTML === 'yes'
    }
  },
  methods: {
    updateLoad: function (e) {
      // var self = this
      // self.$data.total = Number(document.getElementById('app_total_load_count').innerHTML)
      // self.$data.current = Number(document.getElementById('app_current_load_count').innerHTML)
    },
    loadSectionList: function () {
      var self = this
      Sections.getSectionList((d) => {
        var _dirList = d
        for (var i = _dirList.length - 1; i >= 0; i--) {
          if (_dirList[i] === '' || !_dirList[i]) {
            _dirList.splice(i, 1)
          }
        }
        // if (document.location.href.split('wave=').length <= 1) {
        //   _dirList.reverse()
        //   _dirList.push('section0')
        //   _dirList.reverse()
        // }
        if (Sections.getSite() === '') {
          _dirList.reverse()
          _dirList.push('section0')
          _dirList.reverse()
        }        
        // console.log(_dirList)
        // console.log('Directories')
        // console.log(_dirList)
        self.$data.dirList = _dirList
        self.$data.isReady = true
      }, (e) => {
        console.log(e)
      })
    }
  },
  mounted: function () {
    var self = this
    self.loadSectionList()
    EventBus.$on('section-config-change', (n) => {
      self.$data.isReady = false
      self.loadSectionList()
    })
    if (!Sections.inFrame() && Sections.getSite() === ''){
      document.location = '/covid_site/default/sentiment'
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue